import { render, staticRenderFns } from "./sxTabMine.vue?vue&type=template&id=47823d96&scoped=true"
import script from "./sxTabMine.vue?vue&type=script&lang=js"
export * from "./sxTabMine.vue?vue&type=script&lang=js"
import style0 from "./sxTabMine.vue?vue&type=style&index=0&id=47823d96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47823d96",
  null
  
)

export default component.exports